export default function genererDispositifAccessoires() {
  return {
    quantite: 0,
    accessoireId: null,
  };
}
